fx.ns("desktop.print", class PrintEditorHistory extends shared.EditorHistory {


     valid(action)
    {
        if (action.model instanceof models.ProductPrintPage && action.impacts("quantity"))
            return false;
        
        return super.valid(action);
    }

});